import React, { Component } from 'react';
import { connect } from 'react-redux';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import { closeHandler} from './messagesHelper';
import Logger, {LOG_LEVELS, MESSAGE_TYPES} from '../../utils/logger';

const log = new Logger('SYSTEM_ERRORS', LOG_LEVELS.ERROR);

class SystemErrors extends Component {
  render() {
    log.debug('render(): ', this.props);
    return (
      <div>
        { this.props.messages.length === 0 ? <div></div> : 
          <aui-service-notification type="message">
              {
                this.props.messages.map((entry, index) => {
                  return (
                    <s-banner key={index} nodismiss={true}>
                      <LanguageStringResolver
                        className={'error-text'}
                        string={entry.message.languageString}
                        tooltip={entry.message.extendedLanguageString}
                        params={entry.args}
                      />
                      <a type="button" Ref="dismiss-button" class="vertical-center" aria-label="Close">
                        <s-icon name="close" onClick={closeHandler(entry, log)}></s-icon>
                      </a>
                    </s-banner>
                  )
                })
              }
          </aui-service-notification>
        }   
      </div>
    );
  }
}


SystemErrors.defaultProps = {
};

// Which props do we want to inject, given the global state?
function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): ', state, props);
  const inAppMessages = (state.logger && state.logger.inAppMessages) || [];
  const types = [MESSAGE_TYPES.SYSTEM_ERROR];
  const scopes = Array.isArray(props.scopes) ? props.scopes : typeof props.scopes === 'string' ? [props.scopes] : undefined;
  const messageIds = Array.isArray(props.messageIds) ? props.messageIds : typeof props.messageIds === 'number' ? [props.messageIds] : undefined;
  const messages = inAppMessages.filter((entry) => {
    return entry.message && (!types || types.indexOf(entry.message.type) >=0 ) && (!scopes || scopes.indexOf(entry.scope) >= 0) && (!messageIds || messageIds.indexOf(entry.message.id) >=0);
  });
  const messagesByType = messages.reduce((byType, entry) => {
    if (!entry && !entry.message) {
      return byType;
    }
    if (!byType[entry.message.type]) {
      byType[entry.message.type] = []
    }
    byType[entry.message.type].push(entry);
    return byType;
  }, {});
  return {
    messages,
    messagesByType
  };
  }

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(SystemErrors);